module.exports = "/_next/static/images/ff9865365b8c2ee8c23d824b46f75d12-girl-holding-card-landing@lg.jpg";